import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { PhotoPlaceholder } from '../../../../Placeholders/PhotoPlaceholder';
import { PhotoButton, PhotoCard, PhotoImage } from './styled';
import { GalleryItemProps, PhotoButtonEnum } from './types';

export const GalleryItem: React.FC<GalleryItemProps> = ({
  id,
  url,
  isLoading = false,
  handleDelete,
  handleRotateRight,
  handleRotateLeft
}) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });

  const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

  if (isLoading) {
    return <PhotoPlaceholder handleDelete={handleDelete} />;
  }

  return (
    <PhotoCard
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      $isDragging={isDragging}
      transform={transform}
      transition={transition}
      data-cy="item-modal-photo-card"
    >
      <PhotoButton
        onClick={handleDelete}
        onPointerDown={stopPropagation}
        onTouchStart={stopPropagation}
        iconType={PhotoButtonEnum.Delete}
        data-cy="item-modal-photo-icon-delete"
        aria-label="Delete photo"
      />
      <PhotoButton
        onClick={handleRotateRight}
        iconType={PhotoButtonEnum.RotateRight}
        onPointerDown={stopPropagation}
        onTouchStart={stopPropagation}
        data-cy="item-modal-photo-icon-rotate-right"
        aria-label="Rotate photo right"
      />
      <PhotoButton
        onClick={handleRotateLeft}
        onPointerDown={stopPropagation}
        onTouchStart={stopPropagation}
        iconType={PhotoButtonEnum.RotateLeft}
        data-cy="item-modal-photo-icon-rotate-left"
        aria-label="Rotate photo left"
      />
      {url && <PhotoImage src={url} alt={url} width={20} height={105} />}
    </PhotoCard>
  );
};
